import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_locking_devices_on_ladders_ladders_not_secure'

export const dataPointDefinition = {
  retracedId: 'no_locking_devices_on_ladders_ladders_not_secure',
  name: 'No locking devices on ladders (ladders not secure when open or in use)',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-mat-11x',
      number: 'HS-MAT-4-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-mat-9',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-37,Yes',
      machineShowHide: '[2],hs-37,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-mat-11x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31420,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
